import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import css from "./cartonchecss.module.css"; // Адаптуй стилі до свого CSS-модуля

export default function CartonChaResults() {
  const [data, setData] = useState(null);
  const documentId = "24ac945b-7109-489a-8901-d3667388f6a0";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "rating", documentId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          console.error("Документ не знайдено");
        }
      } catch (error) {
        console.error("Помилка при отриманні документа:", error);
      }
    };

    fetchData();
  }, []);

  if (!data) return <p>Завантаження...</p>;

  return (
    <div className={css.ratingResultsContainer}>
      <h2>Порівняння книг</h2>

      <div className={css.bookBlock}>
        <h3>{data.firstBook}</h3>
        <p>Рейтинг: {data.firstRating}</p>
        {data.bookFoto && (
          <img
            src={data.bookFoto}
            alt="Обкладинка першої книги"
            className={css.coverImage}
          />
        )}
      </div>

      <div className={css.bookBlock}>
        <h3>{data.secondBook}</h3>
        <p>Рейтинг: {data.secondRating}</p>
        {data.fotoRozgort && (
          <img
            src={data.fotoRozgort}
            alt="Розгортка другої книги"
            className={css.coverImage}
          />
        )}
      </div>
    </div>
  );
}
